import { GetVenueOperatorContactPersonType as ApiVenueOperatorContactPersonType } from 'src/api/generated/touring/types';
import { mapContact, mapLinkableEntityType } from '../../../common';
import { VenueOperatorContactPersonType } from '../../types';

export const mapVenueOperatorContactPerson = (
  apiContactPerson: ApiVenueOperatorContactPersonType
): VenueOperatorContactPersonType => {
  return {
    person: mapLinkableEntityType(apiContactPerson.person),
    jobTitle: apiContactPerson.jobTitle ?? null,
    contact: mapContact(apiContactPerson.contact),
  };
};
